/* This example requires Tailwind CSS v2.0+ */
import { Listbox, Transition } from '@headlessui/react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { cn } from '../../../../utils';

const MdOutlineCheck = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdOutlineCheck)
);
const MdOutlineKeyboardArrowDown = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdOutlineKeyboardArrowDown)
);

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function CustomDropdown({
  dropdownItems,
  selected,
  setSelected,
  label,
  width = '',
  height = 'h-[48px]',
  context,
  noBorderRadius,
  dropdownItemsWidth,
  className,
  btnTxtClassName,
}) {
  const router = useRouter();
  const { tag_filter = 'most_popular' } = router?.query;

  const lang = useSelector(({ common }) => common?.language);

  const getSelectedDropdownFromUrl = () => {
    return dropdownItems.filter((item) => {
      return item.value === tag_filter;
    });
  };

  const updateRouteForTags = (item) => {
    if (context === 'community_tags') {
      router.push({
        pathname: router?.pathname,
        query: { ...router?.query, tag_filter: item?.value },
      });
    }
  };

  const updateSelectedValueForTags = () => {
    if (context === 'community_tags') {
      const [selectedDropdown] = getSelectedDropdownFromUrl();
      setSelected(selectedDropdown);
    }
  };

  const handleChange = (item) => {
    setSelected(item);
    updateRouteForTags(item);
  };

  useEffect(() => {
    updateSelectedValueForTags();
  }, [tag_filter]);

  useEffect(() => {
    if (tag_filter && context === 'community_tags') {
      const [selectedDropdown] = getSelectedDropdownFromUrl();
      setSelected(selectedDropdown);
    } else if (!selected) {
      setSelected(dropdownItems[0]);
    }
  }, [lang]);

  return (
    // <div className=''>
    <Listbox value={selected} onChange={handleChange}>
      {({ open }) => (
        <div
          className={cn(!noBorderRadius && 'rounded-full', width, className)}
        >
          <Listbox.Button
            className={`relative ${height} w-full border-[1px] border-[#DBD9D9]   bg-transparent ${!noBorderRadius ? 'rounded-full' : ''} flex cursor-default items-center pl-6 pr-10 text-left focus:border-gray-500   focus-visible:outline-none sm:text-sm`}
          >
            {/* <span className='flex items-center'> */}
            <span
              className={cn(' truncate text-[14px] text-high', btnTxtClassName)}
            >
              {context === 'postType'
                ? label
                : selected
                  ? selected.name
                  : label}
            </span>
            {/* </span> */}
            <span className='pointer-events-none absolute inset-y-0 right-0 mx-3 flex items-center pt-[2px]'>
              <MdOutlineKeyboardArrowDown
                className='text-primary'
                aria-hidden='true'
              />
            </span>
          </Listbox.Button>
          <Transition
            show={open}
            as={Fragment}
            leave='transition ease-in duration-100'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Listbox.Options
              className={` ${dropdownItemsWidth ? `min-w-[${dropdownItemsWidth}]` : 'min-w-[250px]'}  absolute z-[100] mt-0 rounded-md bg-white  p-4 text-base shadow-md ring-1 ring-black ring-opacity-5  focus:outline-none sm:text-sm`}
            >
              {dropdownItems.map((item, index) => (
                <Listbox.Option
                  key={index}
                  className={({ active }) =>
                    classNames(
                      active ? 'text-black ' : 'text-gray-900',
                      'relative cursor-default select-none px-4 py-2 hover:bg-gray-100'
                    )
                  }
                  value={item}
                >
                  {({ selected, active }) => (
                    <>
                      <div className='flex items-center justify-between gap-[6px] '>
                        <span
                          className={classNames(
                            selected ? 'font-semibold' : 'font-normal',
                            'block truncate'
                          )}
                        >
                          {item.name}
                        </span>
                        {selected ? (
                          <MdOutlineCheck
                            className='h-5 w-5 text-high'
                            aria-hidden='true'
                          />
                        ) : null}
                      </div>
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
    // </div>
  );
}
